<label>
  {{ 'reward.status.sold.out' | translate }}
</label>
